import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import WeddingBannerImg from '../../../Assets/images/DFL/landing-page-img/wedding-banner-mobile.png'

const WeddingBanner = () => {
    return (
        <>
            <div className='dfl_wedding_banner_section'>
                <Container className='dfl_custome_container_staticpage'>
                    <Row className='w-100 m-auto'>
                        {/* <Col sm={12} md={6} lg={6} className="p-0">
                            <div className='text-center'>
                                <Image src={WeddingBannerImg} className="img-fluid" alt="Wedding banner Image" />
                            </div>
                        </Col> */}
                        <Col sm={12} md={{ span: 6, offset: 6 }} lg={{ span: 6, offset: 6 }} className="dfl_eng_box">
                            <div className='def_wedding_text_box banner_cotntent'>
                                <Image src={WeddingBannerImg} className="img-fluid dfl_wed_banner_d_none_desktop" alt="Wedding banner Image" />
                                <h1>WEDDING RINGS AND ANNIVERSARY BANDS</h1>
                                <h2 className='text-center'>SAY "I DO FOREVER" WITH DFL WEDDING RINGS</h2>
                                <p>Start your forever or celebrate your eternal love with beautiful wedding rings and stunning anniversary bands. Handcrafted to the highest standards with meticulously selected materials and diamonds. Find a perfect match to your engagement ring or make a statement with an eternity band.</p>
                                <NavLink to="/jewellery/wedding-rings">Shop rings</NavLink>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default WeddingBanner